function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6923 12.7692H30.3077V34H10V12.7692H14.6154V14.6154H25.6923V12.7692ZM13.6923 22H26.6154V20.1538H13.6923V22ZM13.6923 29.3846H26.6154V27.5385H13.6923V29.3846ZM16.4615 12.7692V10H23.8462V12.7692H16.4615Z",
  fill: "white"
});
function SvgClipboardIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIco);
export default __webpack_public_path__ + "static/media/clipboard_ico.8274a07f9ee2e7a2fcc8250860909189.svg";
export { ForwardRef as ReactComponent };